const CATEGORY = 'Try Out'

export const tryout = (track) => ({
    preStart(name) {
        track(CATEGORY, 'Sebelum mulai', name)
    },
    cancel(name) {
        track(CATEGORY, 'Batal', name)
    },
    start(name) {
        track(CATEGORY, 'Kerja', name)
    },
    pause(name) {
        track(CATEGORY, 'Jeda', name)
    },
    resume(name) {
        track(CATEGORY, 'Melanjutkan', name)
    },
    answer(name, number) {
        track(CATEGORY, 'Jawab', name, number)
    },
    questionChange(name, number) {
        track(CATEGORY, 'Ganti soal', name, number)
    },
    flag(name, number) {
        track(CATEGORY, 'Menandai', name, number)
    },
    next(name, number) {
        track(CATEGORY, 'Soal setelah', name, number)
    },
    previous(name, number) {
        track(CATEGORY, 'Soal sebelum', name, number)
    },
    normalValue(name, number) {
        track(CATEGORY, 'Nilai normal', name, number)
    },
    increaseFont(name) {
        track(CATEGORY, 'Font tambah', name)
    },
    decreaseFont(name) {
        track(CATEGORY, 'Font kurang', name)
    },
    finish(name) {
        track(CATEGORY, 'Selesai', name)
    },
    showDesktopQuestionNavigator(name) {
        track(CATEGORY, 'Tampil navigasi pertanyaan di desktop', name)
    },
    hideDesktopQuestionNavigator(name) {
        track(CATEGORY, 'Sembunyikan navigasi pertanyaan di desktop', name)
    },
})
